import { Component, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { BaseService } from 'src/app/system-common/services/base.service';

@Component({
  selector: '',
  template: '',
})
export class ContestWiseHandler extends BaseSearchComponent<BaseService> implements OnInit {
  birthdayReminderResponseData;
  birthdayReminderInfo = [];

  constructor(
    public service: BaseService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, router);
    // this.geBirthDayReminders();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}
